import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlProgramResponseModel, IUnitControlRequestModel } from '@apps-common/types/portal/unit-control'

export const unitControlProgram = async (model: IUnitControlRequestModel, reservedId: number): Promise<IUnitControlProgramResponseModel> =>
  axios.post(`/unitcontrol/program?reservedId=${reservedId}`, model).then((res) => ({ message: res?.data?.msg, data: res?.data?.data }))

type Props = {
  model: IUnitControlRequestModel
  reservedId?: number
}

export const useUnitControlProgram = (
  notify?: boolean,
  onSuccess?: (data: IUnitControlProgramResponseModel) => void,
  onError?: (variables: Props) => void
) =>
  useMutation({
    mutationKey: ['unitControlProgram'],
    mutationFn: ({ model, reservedId = 0 }: Props) => unitControlProgram(model, reservedId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(data?.message || 'Commands sent.')
      }
    },
    onError: (error, variables) => {
      if (notify) {
        toastError(error?.message || 'Failed to send commands, please try again.')
      }
      if (onError) {
        onError(variables)
      }
    },
    throwOnError: false
  })
